
import React, { useState } from "react";
import TopBar from "./topbar.js"; // navbar component
import MergedComponent from "./merged.js";
import SurveyStatus from "./tickets.js";
import DiscrepancyList from "./discrepancies.js";
import ApprovedClaimsList from "./approveclaims.js";

const Home = () => {
  const [activeSection, setActiveSection] = useState("Dashboard");

  const handleNavClick = (section) => {
    setActiveSection(section);
  };

  return (
    <div>
      {/* <TopBar onNavClick={handleNavClick} /> */}

      <div className="content">
        {activeSection === "Dashboard" && <MergedComponent />}
       
      </div>
    </div>
  );
};

export default Home;
